<template>
  <div v-if="isMobile" class="tw:py-2">
    <EdroneSelectCustom
      :multiple="false"
      :options="visibleTabs"
      :selected-options="selectedTab"
      controlled
      @select="handleSelect"
    >
      <template #option="{ option }">
        <slot :option="option" name="option">
          <span class="tw:flex tw:w-full close-EdroneSelectCustom">{{ option.name }}</span>
        </slot>
      </template>
      <template #selected="{ selected }">
        <div class="tw:flex tw:w-full tw:pe-8">
          <slot :selected="selected" name="selected">
            <span v-if="!Array.isArray(selected)" class="tw:flex tw:w-full">{{ selected.name }}</span>
          </slot>
        </div>
      </template>
    </EdroneSelectCustom>
  </div>
  <EdroneTabGroup v-else :type="type">
    <EdroneTab
      v-for="tab in visibleTabs"
      :key="tab.id || tab.name"
      :active="tab.active"
      :disabled="tab.disabled"
      :type="type"
      :unique-id="tab.uniqueId || uniqueId"
      @click="handleSelect(tab)"
    >
      <slot :tab="tab" name="tab">
        {{ tab.name }}
      </slot>
      <template #badge>
        <slot :tab="tab" name="badge" />
      </template>
    </EdroneTab>
  </EdroneTabGroup>
</template>

<script lang="ts" setup>
import EdroneSelectCustom from "edrone-components/EdroneSelectCustom.vue";
import EdroneTab from "edrone-components/EdroneTab.vue";
import EdroneTabGroup from "edrone-components/EdroneTabGroup.vue";
import { computed } from "vue";
import { useIsScreenMobile } from "vue-app/composables/useIsScreenMobile/useIsScreenMobile.composable";

type ResponsiveTabsType = "underline" | "border";

export interface ResponsiveTabItem {
  id?: string | number;
  name: string;
  active?: boolean;
  disabled?: boolean;
  amount?: string | number;
  label?: string;
  path?: string;
  hidden?: boolean;
  uniqueId?: string;
}

interface Props {
  tabs: ResponsiveTabItem[];
  type?: ResponsiveTabsType;
  uniqueId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  type: "underline",
  uniqueId: "",
});

defineSlots<{
  option(props: { option: ResponsiveTabItem }): unknown;
  selected(props: { selected: ResponsiveTabItem | ResponsiveTabItem[] }): unknown;
  tab(props: { tab: ResponsiveTabItem }): unknown;
  badge(props: { tab: ResponsiveTabItem }): unknown;
}>();

const emit = defineEmits<{
  select: [tab: ResponsiveTabItem];
}>();

const { isMobile } = useIsScreenMobile();

const visibleTabs = computed(() => props.tabs.filter((tab) => !tab.hidden));
const selectedTab = computed(() => visibleTabs.value.find((tab) => tab.active) || visibleTabs.value[0]);

function handleSelect(tab: ResponsiveTabItem) {
  emit("select", tab);
}
</script>
